import { useCallback } from 'react';
import { formGuardStore, useFormGuardStore } from '@/shared/lib/formGuardStore';

export type FormGuardState = {
  isDirty: boolean;
  allowNavigation: boolean;
};

export const useFormGuard = () => {
  return useFormGuardStore();
};

export const useFormGuardActions = () => {
  const setIsDirty = useCallback((isDirty: boolean) => {
    formGuardStore.setState({ isDirty });
  }, []);

  const setAllowNavigation = useCallback((allowNavigation: boolean) => {
    formGuardStore.setState({ allowNavigation });
  }, []);

  const resetFormGuard = useCallback(() => {
    formGuardStore.setState({ isDirty: false, allowNavigation: false });
  }, []);

  return {
    setIsDirty,
    setAllowNavigation,
    resetFormGuard,
  };
};
